<template>
    <div>
        <div style="height: 3.75rem;"> </div>
        <div class='header'>
            <div class="header_box">
                <router-link to="/home" style="height: 22px;">
                    <img class="logo" src="../../assets/home/logo.png" alt="" @click="handleHeader(0, { id: 0 })">
                </router-link>
                <div>
                    <ul class="healthName">
                        <li v-for="(i, idx) in headerArr" :class="idx == isActive ? 'active' : 'activer'"
                            @click="handleHeader(idx, i)" :key="i.id" :title="i.name">
                            {{ i.name }}
                        </li>
                    </ul>
                </div>
                <div>
                    <div ref="shop">
                        <el-badge :value="$store.state.user.cart_num == 0 ? '' : $store.state.user.cart_num"
                            class="item" type="primary">
                            <img class="shop" @click="goShopCar" src="../../assets/home/newCart.png" alt="">
                        </el-badge>
                    </div>
                    <div v-if="!$store.state.user.id" style="cursor: pointer;margin-left: 30px;">
                        <el-button type="primary" size="small" @click="login">
                            登录/注册</el-button>
                    </div>
                    <!-- <div @click="login" class="login" v-if="!$store.state.user.id">登录/注册</div> -->

                    <el-popover v-else placement="bottom" popper-class="loginPover" trigger="hover" :open-delay="500">
                        <div class="exit" @click="exit">
                            退出登录
                        </div>
                        <div slot="reference" class="buddha" @click="goMycenter">
                            <img style="cursor: pointer;" :src="$store.state.user.portrait"
                                v-if="$store.state.user.portrait" alt="">
                            <img style="cursor: pointer;" src="../../assets/home/buddha.png" alt="" v-else>
                            <p style="cursor: pointer;">个人中心</p>
                        </div>
                    </el-popover>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    components: {},
    data() {
        // 这里存放数据
        return {
            page: 1,
            pageSize: 3,
            headerArr: [

            ],
            isActive: -1,
            isLogin: false,//是否登录,
            value: 10,
            headerList: [],
            history: 0
        }
    },
    // 监听属性 类似于data概念
    computed: {},
    created() {
        this.getScenes()
    },
    watch: {
        "$store.state.headerIndex"(val){
            console.log(val);
            this.isActive = val
        }

    },
    // 方法集合
    methods: {
        // 获取导航栏
        getScenes() {
            this.$home.scenes().then(res => {
                if (res.code == 200) {
                    res.data.list.map((i, idx) => {
                        i.list = {
                            sheet: [],
                            song: [],
                            label: []
                        }
                        i.flag = false
                        if(this.$store.state.headerIndex != -1){
                            this.isActive = this.$store.state.headerIndex
                        }
                    })
                    res.data.list.unshift(
                        {
                            id: 0,
                            name: '首页',
                        })
                    res.data.list.push(
                        {
                            id: 99,
                            name: '帮助中心',
                        }
                    )
                    this.$store.commit('setCartNum', res.data.num)
                    this.headerArr = res.data.list
                }

            }).catch(err => {
                console.log(err);
            })
        },
        login() {
            this.$store.commit('setDialogVisible', true)
        },
        exit() {
            this.$router.push({
                path: '/home'
            })
            this.isActive = 0
            this.$store.commit('updateCateId', '')
            this.$bus.$emit('homeShow')
            this.$store.commit('setUser', {})
        },
        goShopCar() {
            if (!this.$store.state.user.token) return this.$store.commit("setDialogVisible", true);
            this.$store.commit('setShopActive', true)
            this.$router.push({
                path: '/shoppingCart'
            })
        },
        // 点击导航栏
        handleHeader(idx, item) {
            this.$store.commit('setHeaderIndex', idx)
            if (item.id == 0) {
                this.$router.push({
                    path: 'home'
                })
                this.$store.commit('updateCateId', '')
                return
            } else if (item.id == 99) {
                this.$router.push({
                    path: 'Help'
                })
                return
            } else {
                this.$router.push({
                    path: 'sceneHome'
                })
                // 存下导航栏的下标
                this.$store.commit('updateCateId', item.id)
            }
        },
        goMycenter() {
            if (!this.$store.state.user.token) return this.$store.commit("setDialogVisible", true);
            this.$router.push({
                path: '/personalCenter',
                query: {
                    isActive: 0
                }
            })
        }
    }
}
</script>
<style scoped lang="less">
::v-deep .el-badge {
    height: 32px;
}

::v-deep .el-popper {
    min-width: 3.125rem;
}

::v-deep .el-button {
    background: #D92A20;
    opacity: 1;
    padding: .5rem .625rem;
    font-size: .9375rem;
    // line-height: 33px;
    text-align: center;
    font-family: PingFang SC-Regular, PingFang SC;
    font-weight: 400;
    color: #FFFFFF;
    cursor: pointer;
    // margin: 0 1.5625rem;
}

.exit {
    min-width: 120px;
    text-align: center;
    cursor: pointer;
    padding: .625rem;

    &:hover {
        background-color: #f3f4f7;
    }
}

::v-deep .el-badge__content {
    font-size: .75rem;
    line-height: 1.125rem;
    border: none;
}

::v-deep .el-badge__content.is-fixed {
    top: 2px;
    right: 11px;
}

.header {
    width: 100%;
    background: #FFF9F9;
    box-sizing: border-box;
    position: fixed;
    top: 0;
    opacity: 1;
    z-index: 99;
    padding: 0 80px;


    .header_box {
        margin: 0 auto;
        min-width: 1200px;
        height: 60px;
        display: flex;
        align-items: center;
        box-sizing: border-box;
        justify-content: space-between;

        >div {
            display: flex;
            align-items: center;
        }

        .logo {
            width: 100px;
            height: 22px;
        }

        ul {
            display: flex;
            // margin-left: 1.875rem;
            overflow-x: auto;

            li {
                flex-shrink: 0;
                margin-right: 54px;
                list-style: none;
                font-size: 14px;
                font-family: PingFang SC-Regular, PingFang SC;
                font-weight: 400;
                color: #333333;
                // margin-right: 54px;
                cursor: pointer;
                position: relative;
                line-height:60px;
            }

            .active {
                color: #D92A20;
                &::before {
                    content: '';
                    position: absolute;
                    left: 50%;
                    transform: translate(-50%);
                    bottom: 0;
                    width: 18px;
                    height: 4px;
                    background: #D92A20;
                }
            }
        }


        .shop {
            width: 32px;
            height: 32px;
            cursor: pointer;
        }

        .newshop {
            cursor: pointer;
            padding: 8px 7.5px;
            position: relative;
            top: 1px;
        }

        .login {
            padding: .3125rem .625rem;
            margin-left: 1.5625rem;
            background: #D92A20;
            border-radius: .1875rem;
            opacity: 1;
            border: .0625rem solid #D92A20;
            font-size: .9375rem;
            // line-height: 33px;
            text-align: center;
            font-family: PingFang SC-Regular, PingFang SC;
            font-weight: 400;
            color: #FFFFFF;
            cursor: pointer;
            margin-right: 1.5625rem;
        }

        ::v-deep .el-avatar--icon {
            display: inline-block;
            width: 1.875rem;
            height: 1.875rem;
            background: #CECECE;
            line-height: 1.875rem;
            opacity: 1;
        }

        .buddha {
            margin-left: 40px;
            display: flex;
            color: white;
            align-items: center;

            p {
                margin-left: .3125rem;
                font-size: .9375rem;
                font-family: PingFang SC-Regular, PingFang SC;
                font-weight: 400;
                color: #666666;
                line-height: 1.125rem;
                flex-shrink: 0;
            }

            img {
                width: 32px;
                height: 32px;
                border-radius: 50%;
            }
        }
    }




}
</style>
